<template>
  <main>
    <v-content>
      <v-container fluid grid-list-lg>
        <h1>Page Not Found</h1>
      </v-container>
    </v-content>
  </main>
</template>

<script>
export default {
  name: "page-not-found"
};
</script>

<style>
</style>
